(function() { window.GUID_9fa75738_10be_4bce_9629_35c6afa65c10 = { getGuid: function() { return "9fa75738-10be-4bce-9629-35c6afa65c10"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let SportId;
        (function (SportId) {
            SportId[SportId["Badminton"] = 1] = "Badminton";
            SportId[SportId["Dart"] = 2] = "Dart";
            SportId[SportId["Volleyball"] = 3] = "Volleyball";
            SportId[SportId["Pool"] = 4] = "Pool";
            SportId[SportId["Other"] = 5] = "Other";
            SportId[SportId["Bocce"] = 6] = "Bocce";
            SportId[SportId["Foosball"] = 7] = "Foosball";
            SportId[SportId["Bowling"] = 8] = "Bowling";
            SportId[SportId["Tennis"] = 9] = "Tennis";
            SportId[SportId["CornHole"] = 10] = "CornHole";
            SportId[SportId["PickleBall"] = 11] = "PickleBall";
            SportId[SportId["VideoGames"] = 12] = "VideoGames";
            SportId[SportId["HorseShoes"] = 13] = "HorseShoes";
            SportId[SportId["Shuffleboard"] = 14] = "Shuffleboard";
            SportId[SportId["Skeeball"] = 15] = "Skeeball";
            SportId[SportId["Basketball"] = 16] = "Basketball";
            SportId[SportId["TableTennis"] = 17] = "TableTennis";
            SportId[SportId["AirHockey"] = 18] = "AirHockey";
        })(SportId = Enumeration.SportId || (Enumeration.SportId = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=SportId.pre.js.map
